import React from 'react';
import { FormattedMessage } from '../../../../util/reactIntl';
import ReviewsErrorMaybe from '../ReviewsErrorMaybe/ReviewsErrorMaybe';
import { Reviews, H4 } from '../../../../components';

import { REVIEW_TYPE_OF_PROVIDER, REVIEW_TYPE_OF_CUSTOMER } from '../../../../util/types';

import css from '../../ProfilePage.module.css';

const MobileReviews = ({ reviews, queryReviewsError, isBuyer, showReviewAsCustomer }) => {

  const reviewsOfProvider = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);
  const reviewsOfCustomer = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER);

  return (
    <div className={css.mobileReviews}>
      {isBuyer ? null : (
        <>
          <H4 as="h2" className={css.mobileReviewsTitle}>
            <FormattedMessage
              id="ProfilePage.reviewsFromMyCustomersTitle"
              values={{ count: reviewsOfProvider.length }}
            />
          </H4>
          <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />
          <Reviews reviews={reviewsOfProvider} />
        </>
      )}
      {showReviewAsCustomer ? (
        <>
          <H4 as="h2" className={css.mobileReviewsTitle}>
            <FormattedMessage
              id="ProfilePage.reviewsAsACustomerTitle"
              values={{ count: reviewsOfCustomer.length }}
            />
          </H4>
          <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />
          <Reviews reviews={reviewsOfCustomer} />
        </>
      ) : null}
    </div>
  );
};

export default MobileReviews;
